module.exports = __webpack_public_path__ + "static/logo-tralee-marathon-8a270fab2091b05f1def622fd8672976.png";